export enum Features {
  InnsiktTimerApproveView = 'innsikt-export_approve-view',
  InnsiktTimerScheduleView = 'innsikt-export_schedule-view'
}